'use client';
import { useState, useEffect } from 'react';
import { useCustomContext } from "../../CustomComponents/CustomComponents";
import DatasetDS from '../../../DataServices/DatasetDs';
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

function EditDatasetLogic(dataset, onSave, onCancel, getResolvedAcroList) {

  const useremail = localStorage.getItem("email");
  const { showAlert, showToast, hud, stopHudRotation } = useCustomContext();
  const dsApi = new DatasetDS();
  const [originalData, setOriginalData] = useState(null);
  const [universalFormFile, setUniversalFormFile] = useState(null);
  // 🔹 INIT (ADD SAME FIELDS AS ADD)
  const [formData, setFormData] = useState({
    id: dataset._id || "",
    datasetID: dataset.datasetID || "",
    datasetName: dataset.datasetName || "",
    datasetDisplayName: dataset.datasetDisplayName || "",
    state: dataset.state || "",

    entryType: "",
    objectType: dataset.objectType || "",

    zohoDepartmentID: dataset.zohoDepartmentID || "",
    replyToEmail: dataset.smtpSettings?.replyToEmail || "",
    smtpFromEmail: dataset.smtpSettings?.fromEmail || "",
    smtpSubject: dataset.smtpSettings?.subject || "",
    universalFormS3Key:
      dataset.pdfForm?.s3Key || "",
    acroFields:
      dataset.pdfForm?.acroFields || {},
    dailyEntryLimit: dataset.thresholds?.dailyEntryLimit ?? "",
    qaCompletionDays: dataset.thresholds?.qaCompletionDays ?? "",
    ignoredFileApprovalDays: dataset.thresholds?.ignoredFileApprovalDays ?? "",
    datasetOPRARequestSendEnable: dataset.datasetOPRARequestSendEnable ?? false,
    // fromRange: dataset.dateRange?.from ?? "",
    // toRange: dataset.dateRange?.to ?? "",
  });

  useEffect(() => {
    if (!dataset) return;
    const initialData = {
      id: dataset._id || "",
      datasetID: dataset.datasetID || "",
      datasetName: dataset.datasetName || "",
      datasetDisplayName: dataset.datasetDisplayName || "",
      state: dataset.state || "",
      entryType: dataset.entryType || "",
      objectType: dataset.objectType || "",
      zohoDepartmentID: dataset.zohoDepartmentID || "",
      replyToEmail: dataset.smtpSettings?.replyToEmail || "",
      smtpFromEmail: dataset.smtpSettings?.fromEmail || "",
      smtpSubject: dataset.smtpSettings?.subject || "",
      universalFormS3Key:
        dataset.pdfForm?.s3Key || "",
      acroFields:
        dataset.pdfForm?.acroFields || {},
      dailyEntryLimit: dataset.thresholds?.dailyEntryLimit ?? "",
      qaCompletionDays: dataset.thresholds?.qaCompletionDays ?? "",
      ignoredFileApprovalDays: dataset.thresholds?.ignoredFileApprovalDays ?? "",
      datasetOPRARequestSendEnable: dataset.datasetOPRARequestSendEnable ?? false,
      // fromRange: dataset.dateRange?.from ?? "",
      // toRange: dataset.dateRange?.to ?? "",
    };
    setFormData(initialData);
    setOriginalData(initialData);
  }, [dataset]);


  const [errors, setErrors] = useState({});
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }

    // if (name === "fromRange" || name === "toRange") {
    //   if (value === "" || Number(value) <= 0) {
    //     setFormData(prev => ({
    //       ...prev,
    //       [name]: value === "" ? "" : Number(value)
    //     }));
    //   }
    //   return;
    // }

    // 🔹 RESET DEPENDENT FIELDS
    if (name === "entryType") {
      const isRequestBased = value === "Request Based PDF Entry";
      setFormData(prev => ({
        ...prev,
        entryType: value,
        objectType: value === "Counter Based WebSite Entry" || value === "Date Range Based PDF Entry" ? "Grouped Object" : "",
        // Restore original values when switching back to Request Based, otherwise clear
        replyToEmail: isRequestBased ? (originalData?.replyToEmail ?? "") : "",
        zohoDepartmentID: isRequestBased ? (originalData?.zohoDepartmentID ?? "") : "",
        smtpFromEmail: isRequestBased ? (originalData?.smtpFromEmail ?? "") : "",
        smtpSubject: isRequestBased ? (originalData?.smtpSubject ?? "") : "",
      }));
      return;
    }

    if (name === "datasetName") {

      if (value.length > 50) {
        setErrors(prev => ({
          ...prev,
          datasetName: "Dataset Name cannot exceed 50 characters"
        }));
        return;
      }

      setErrors(prev => ({
        ...prev,
        datasetName: ""
      }));
    }

    if (name === "datasetDisplayName") {

      if (value.length > 50) {
        setErrors(prev => ({
          ...prev,
          datasetDisplayName: "Display Name cannot exceed 50 characters"
        }));
        return;
      }

      setErrors(prev => ({
        ...prev,
        datasetDisplayName: ""
      }));
    }
    if (name === "dailyEntryLimit") {
      const num = value === "" ? "" : Number(value);
      if (value !== "" && (isNaN(num) || num < 0)) return;
      setFormData(prev => ({ ...prev, dailyEntryLimit: value === "" ? "" : num }));
      return;
    }
    if (name === "qaCompletionDays") {
      const num = value === "" ? "" : Number(value);
      if (value !== "" && (isNaN(num) || num < 0 || num > 9)) return;
      setFormData(prev => ({ ...prev, qaCompletionDays: value === "" ? "" : num }));
      return;
    }
    if (name === "ignoredFileApprovalDays") {
      const num = value === "" ? "" : Number(value);
      if (value !== "" && (isNaN(num) || num < 0 || num > 9)) return;
      setFormData(prev => ({ ...prev, ignoredFileApprovalDays: value === "" ? "" : num }));
      return;
    }
    if (name === "datasetOPRARequestSendEnable") {
      setFormData(prev => ({ ...prev, datasetOPRARequestSendEnable: e.target.checked }));
      return;
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // 🔹 SAME VALIDATION AS ADD
  const validateFields = () => {
    let newErrors = {};
    const safeTrim = (v) => (typeof v === "string" ? v.trim() : "");

    if (!safeTrim(formData.datasetID)) newErrors.datasetID = "Dataset ID is required";
    if (!safeTrim(formData.datasetName)) newErrors.datasetName = "Dataset Name is required";
    if (!safeTrim(formData.datasetDisplayName)) newErrors.datasetDisplayName = "Display Name is required";
    if (!safeTrim(formData.state)) newErrors.state = "State is required";

    if (formData.entryType === "Request Based PDF Entry") {
      if (!formData.replyToEmail?.trim())
        newErrors.replyToEmail = "Reply To Email is required";
      else if (!emailRegex.test(formData.replyToEmail))
        newErrors.replyToEmail = "Enter a valid email";

      if (!safeTrim(formData.smtpFromEmail))
        newErrors.smtpFromEmail = "From Email is required";
      else if (!emailRegex.test(formData.smtpFromEmail))
        newErrors.smtpFromEmail = "Enter valid email";

      // if (!safeTrim(formData.smtpSubject))
      //   newErrors.smtpSubject = "Subject is required";
    }

    if (formData.entryType === "Counter Based WebSite Entry" && !formData.objectType) {
      newErrors.objectType = "Object Type is required";
    }
    if (formData.entryType === "Date Range Based PDF Entry" && !formData.objectType) {
      newErrors.objectType = "Object Type is required";
    }
    // if (formData.entryType === "Date Range Based PDF Entry" ) {

    //   if (formData.fromRange === "" || formData.fromRange === null) {
    //     newErrors.fromRange = "From range is required";
    //   }

    //   if (formData.toRange === "" || formData.toRange === null) {
    //     newErrors.toRange = "To range is required";
    //   }

    //   if (formData.fromRange !== "" && isNaN(formData.fromRange)) {
    //     newErrors.fromRange = "From range must be a number";
    //   }

    //   if (formData.toRange !== "" && isNaN(formData.toRange)) {
    //     newErrors.toRange = "To range must be a number";
    //   }

    //   if (formData.fromRange !== "" && formData.toRange !== "") {
    //     const from = Number(formData.fromRange);
    //     const to = Number(formData.toRange);

    //     if (from > to) {
    //       newErrors.fromRange = "From range should not be greater than To range";
    //       newErrors.toRange = "To range should be greater than or equal to From range";
    //     }
    //   }

    // }



    setErrors(newErrors);
    return newErrors;
  };
  const hasChanges = (current, original, acroFieldsList = []) => {  // remove jsonInput param
    if (!original) return true;

    const fieldsToCompare = [
      "datasetID", "datasetName", "datasetDisplayName", "state",
      "entryType", "objectType", "zohoDepartmentID",
      "replyToEmail", "datasetOPRARequestSendEnable", "smtpFromEmail", "smtpSubject",
      "dailyEntryLimit", "qaCompletionDays", "ignoredFileApprovalDays",
    ];

    const basicChanges = fieldsToCompare.some((key) => {
      if (key === "datasetOPRARequestSendEnable") {
        return (current[key] ?? false) !== (original[key] ?? false);
      }
      return (current[key] || "") !== (original[key] || "");
    });

    if (basicChanges) return true;

    // Build currentAcroFields from acroFieldsList (always valid)
    const currentAcroFields = {};
    acroFieldsList.forEach((item) => {
      if (item.key?.trim()) {
        currentAcroFields[item.key.trim()] = item.value;
      }
    });

    const originalAcroFields = original.acroFields || {};
    const currentKeys = Object.keys(currentAcroFields);
    const originalKeys = Object.keys(originalAcroFields);

    if (currentKeys.length !== originalKeys.length) return true;

    for (const key of currentKeys) {
      if ((currentAcroFields[key] || "") !== (originalAcroFields[key] || "")) {
        return true;
      }
    }

    return false;
  };
  const normalizeValue = (value = "") =>
    value.trim().replace(/\s+/g, " ");

  const uploadUniversalForm = async (file, datasetID) => {
    const idToken = localStorage.getItem("idToken");

    const s3 = new S3Client({
      region: process.env.REACT_APP_AWS_REGION,
      credentials: fromCognitoIdentityPool({
        clientConfig: { region: process.env.REACT_APP_AWS_REGION },
        identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
        logins: {
          [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
            idToken,
        },
      }),
    });

    // Dynamic bucket name 
    const bucketName = `${datasetID.toLowerCase()}-${formData.datasetName.trim().replace(/\s+/g, "-").toLowerCase()}-files-${process.env.REACT_APP_ALIAS}`;
    console.log("Bucket Name:", bucketName);

    const s3Key = `UniversalForms/${file.name}`;
    const command = new PutObjectCommand({
      Bucket: bucketName,
      Key: s3Key,
      Body: await file.arrayBuffer(),
      ContentType: "application/pdf",
    });

    await s3.send(command);
    return s3Key;
  };
  const generatePresignedUrl = async (s3Key) => {
    try {
      hud("Generating preview...");
      const idToken = localStorage.getItem("idToken");

      const s3 = new S3Client({
        region: process.env.REACT_APP_AWS_REGION,
        credentials: fromCognitoIdentityPool({
          clientConfig: { region: process.env.REACT_APP_AWS_REGION },
          identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
          logins: {
            [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
              idToken,
          },
        }),
      });

      const { getSignedUrl } = await import("@aws-sdk/s3-request-presigner");
      const { GetObjectCommand } = await import("@aws-sdk/client-s3");

      //  Dynamic bucket name derived from the s3Key's dataset prefix
      //const datasetID = s3Key.split("/")[0];
      const bucketName = `${formData.datasetID.toLowerCase()}-${formData.datasetName.trim().replace(/\s+/g, "-").toLowerCase()}-files-${process.env.REACT_APP_ALIAS}`;
      console.log("Bucket Name (preview):", bucketName);

      const command = new GetObjectCommand({
        Bucket: bucketName,  //  Replaced process.env.REACT_APP_S3_BUCKET_NAME
        Key: s3Key,
      });

      const signedUrl = await getSignedUrl(s3, command, { expiresIn: 300 });
      window.open(signedUrl, "_blank");
    } catch (err) {
      showAlert("Failed to generate preview. Please try again.", [
        { label: "OK", color: "var(--buttonColor)", onClick: () => { } },
      ]);
    } finally {
      stopHudRotation();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) return;
    const resolvedAcroList = getResolvedAcroList();


    if (!hasChanges(formData, originalData, resolvedAcroList) && !universalFormFile) {
      showAlert("No modifications have been identified.", [
        { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
      ]);
      return;
    }
    hud("Updating Dataset...");
    const updatedData = {
      id: formData.id,
      datasetID: normalizeValue(formData.datasetID),
      datasetName: normalizeValue(formData.datasetName),
      datasetDisplayName: normalizeValue(formData.datasetDisplayName),
      state: normalizeValue(formData.state),
      entryType: formData.entryType,
      updated_by_email_id: useremail,

    };
    if (formData.entryType === "Request Based PDF Entry") {
      updatedData.zohoDepartmentID = normalizeValue(formData.zohoDepartmentID);
      updatedData.datasetOPRARequestSendEnable = formData.datasetOPRARequestSendEnable;
      updatedData.smtpSettings = {
        fromEmail: normalizeValue(formData.smtpFromEmail),
        replyToEmail: normalizeValue(formData.replyToEmail),
        subject: normalizeValue(formData.smtpSubject),
      };
    }
    if (formData.entryType === "Counter Based WebSite Entry") {
      updatedData.objectType = formData.objectType;
    }

    if (formData.entryType === "Date Range Based PDF Entry") {
      updatedData.objectType = formData.objectType;
      // updatedData.dateRange = {
      //   from: Number(formData.fromRange),
      //   to: Number(formData.toRange),
      // };    
    }
    updatedData.thresholds = {
      dailyEntryLimit: formData.dailyEntryLimit === "" || formData.dailyEntryLimit == null
        ? 0
        : Number(formData.dailyEntryLimit),
      qaCompletionDays: formData.qaCompletionDays === "" || formData.qaCompletionDays == null
        ? 0
        : Number(formData.qaCompletionDays),
      ignoredFileApprovalDays: formData.ignoredFileApprovalDays === "" || formData.ignoredFileApprovalDays == null
        ? 0
        : Number(formData.ignoredFileApprovalDays),
    };
    try {

      let uploadedS3Key =
        formData.universalFormS3Key || "";

      // UPLOAD NEW FILE IF CHANGED
      if (
        formData.entryType === "Request Based PDF Entry" &&
        universalFormFile
      ) {
        try {
          hud("Uploading universal form...");

          console.warn(
            "Uploading to bucket:",
            `${formData.datasetID.toLowerCase()}-${formData.datasetName.trim().replace(/\s+/g, "-").toLowerCase()}-files-${process.env.REACT_APP_ALIAS}`
          );

          uploadedS3Key = await uploadUniversalForm(
            universalFormFile,
            formData.datasetID
          );
        } catch (uploadError) {
          console.error("PDF Upload Failed:", uploadError);

          stopHudRotation();

          showAlert(
            "Failed to upload file. Contact your administrator.",
            [
              {
                label: "OK",
                color: "red",
                onClick: () => {
                  if (onCancel) {
                    onCancel();
                  }
                },
              },
            ]
          );

          return;
        }
      }

      // BUILD ACROFIELDS
      const acroFieldsObject = {};
      resolvedAcroList.forEach((item) => {
        if (item.key?.trim()) {
          acroFieldsObject[item.key.trim()] = item.value;
        }
      });

      // PDF FORM STRUCTURE
      if (formData.entryType === "Request Based PDF Entry") {

        updatedData.pdfForm = {
          s3Key: uploadedS3Key,
          acroFields: acroFieldsObject,
        };

      }

      console.log("payload", updatedData);

      const res = await dsApi.AP_Dataset_UPDATE(
        updatedData
      );

      const body =
        typeof res.data.body === "string"
          ? JSON.parse(res.data.body)
          : res.data.body;

      if (res.data.statusCode === 200) {
        showToast({
          message: "Dataset Updated Successfully"
        });

        const changeParts = [];

        // FILE
        if (universalFormFile) {
          const hadFileBefore = !!originalData?.universalFormS3Key;
          changeParts.push(hadFileBefore ? "file replaced" : "file uploaded");
        }

        // ACROFIELDS
        if (formData.entryType === "Request Based PDF Entry") {
          const prevAcroFields = originalData?.acroFields || {};
          const prevKeys = Object.keys(prevAcroFields);
          const newKeys = Object.keys(acroFieldsObject);

          const acroChanged =
            prevKeys.length !== newKeys.length ||
            newKeys.some(
              (key) =>
                !(key in prevAcroFields) ||
                String(prevAcroFields[key]) !== String(acroFieldsObject[key])
            ) ||
            prevKeys.some((key) => !(key in acroFieldsObject));

          if (acroChanged) {
            changeParts.push("AcroFields updated");
          }
        }

        // BASIC FIELDS
        const fieldLabels = {
          datasetName: "Dataset Name",
          datasetDisplayName: "Display Name",
          state: "State",
          entryType: "Entry Type",
          objectType: "Object Type",
          smtpFromEmail: "From Email",
          smtpSubject: "Subject",
          zohoDepartmentID: "Zoho Department ID",
          replyToEmail: "Reply To Email",
          datasetOPRARequestSendEnable: "OPRA Request Send Enabled",
          dailyEntryLimit: "Daily Entry Limit",
          qaCompletionDays: "Days Allowed for QA Review",
          ignoredFileApprovalDays: "Days Allowed to Approve Ignored Files/PDFs",
        };

        Object.entries(fieldLabels).forEach(([key, label]) => {
          if (key === "datasetOPRARequestSendEnable"
            ? (formData[key] ?? false) !== (originalData?.[key] ?? false)
            : (formData[key] || "") !== (originalData?.[key] || "")) {
            changeParts.push(`${label} updated`);
          }
        });

        const changeNote =
          changeParts.length > 0
            ? changeParts.join(", ")
            : "no changes detected";
        onSave && onSave(updatedData, false, changeNote);

      } else {

        showAlert(
          body?.message ||
          "Failed to update dataset",
          [
            {
              label: "OK",
              color: "red",
              onClick: () => { }
            }
          ]
        );
      }

    } catch (err) {
      showAlert("Error updating dataset", [
        { label: "OK", color: "red", onClick: () => { } }
      ]);
    } finally {
      stopHudRotation();
    }
  };

  return { formData, errors, handleChange, handleSubmit, setUniversalFormFile, generatePresignedUrl };
}

export default EditDatasetLogic;
